'use strict';

exports.__esModule = true;
exports.AuthToken = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.login = login;
exports.loginWithClientCredentials = loginWithClientCredentials;
exports.refreshToken = refreshToken;
exports.removeToken = removeToken;
exports.hasToken = hasToken;
exports.createToken = createToken;

var _apiClient = require('./network/api-client');

var _store = require('./services/store');

var _store2 = _interopRequireDefault(_store);

var _eventManager = require('./event-manager/event-manager');

var _eventManager2 = _interopRequireDefault(_eventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = { TOKEN: '/oauth/token' };
var token = null;

_eventManager2.default.registerEvent('onAuthenticated');

var auth = {
  login: login,
  loginWithClientCredentials: loginWithClientCredentials,
  refreshToken: refreshToken,
  removeToken: removeToken,
  hasToken: hasToken,
  createToken: createToken
};

exports.default = auth;

/**
 * Authenticates with Quiqup
 * @param {string} username - email address of the user
 * @param {string} password - alphanumerical password of the user
 * @returns {promise} containing success/error after authentication
 */

function login(username, password) {
  var data = {
    grant_type: 'password',
    username: username,
    password: password,
    refresh_token: null
  };

  return (0, _apiClient.post)({ route: API.TOKEN, data: data, includeAuth: false }).then(createToken);
}

/**
 * Authenticates with Quiqup using client_credentials flow
 * @param {string} clientId - your_client_id
 * @param {string} clientSecret - your_client_secret
 * @returns {promise} containing success/error after authentication

 * response payload format:

     {
       "access_token": "<your_token>",
       "token_type": "bearer",
       "expires_in": 604800
     }

 * Then the "access_token" can be used in request headers as "Authorization: Bearer <your_token>"
 */
function loginWithClientCredentials(clientId, clientSecret) {
  var data = {
    grant_type: 'client_credentials',
    clientId: clientId,
    clientSecret: clientSecret,
    refresh_token: null
  };

  return (0, _apiClient.post)({ route: API.TOKEN, data: data, includeAuth: false }).then(createToken);
}

/**
 * Refreshes token with Quiqup
 * @param {string} refresh hash - refresh token supplied at time of authentication
 * @returns {promise} containing success/error after authentication
 */
function refreshToken(hash) {
  if (!hash) {
    if (!token || token && !token.refresh) {
      return _promise2.default.reject('No refresh token');
    }
  }
  var data = {
    grant_type: 'refresh_token',
    refresh_token: hash || token.refresh
  };

  return (0, _apiClient.post)({ route: API.TOKEN, data: data }).then(createToken);
}

/**
 * Clears session token from localstorage/session
 */
function removeToken() {
  token = null;
  _store2.default.remove('token');
}

/**
 * Checks to see if the token is in session or storage
 * @returns {Token} returns Token if available or null
 */
function hasToken() {
  token = token || (_store2.default.get('token') !== undefined ? _store2.default.get('token') : null);

  return token;
}

/**
 * @access private
 */

var AuthToken = exports.AuthToken = function AuthToken(authT, refreshT, expiry) {
  (0, _classCallCheck3.default)(this, AuthToken);

  this.auth = authT || null;
  this.refresh = refreshT || null;
  this.expiry = parseInt(expiry, 10) || 0;
};

/**
 * @access private
 */

// eslint-disable-next-line no-shadow


function createToken(_ref) {
  var accessToken = _ref.accessToken,
      refreshToken = _ref.refreshToken,
      expiresIn = _ref.expiresIn;

  token = new AuthToken(accessToken, refreshToken, expiresIn);
  _store2.default.add('token', token);
  _eventManager2.default.dispatchEvent('onAuthenticated', token);

  return token;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/auth.js
// module id = 117
// module chunks = 0